import { useRecoilValue } from "recoil";

import { FEAvailableSystemParamMetadata } from "../models";
import { systemSettingsDtoAtom } from "../recoil";

export const useSystemParams = (): FEAvailableSystemParamMetadata => {
  const systemSettingsDto = useRecoilValue(systemSettingsDtoAtom);

  return systemSettingsDto?.metadata ?? {};
};
